import ptBr from "./texts/pt-br";

const texts = {
  "pt-BR": ptBr,
};

export default texts;
